import React, { useMemo } from 'react';
import { format } from 'date-fns';

import TimelineGroup from './TimelineGroup';

import {
  TimelineItemAPI,
  TimelineStepperProps
} from '../../types/leadActivity';

const TimelineStepper: React.FC<TimelineStepperProps> = ({
  timelineData,
  className = ''
}) => {
  const timelineGroups = useMemo(() => {
    const groups = timelineData.reduce<Record<string, TimelineItemAPI[]>>(
      (acc, item) => {
        const date = format(new Date(item.timestamp), 'yyyy-MM-dd');
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(item);
        return acc;
      },
      {}
    );

    return Object.entries(groups)
      .sort(([a], [b]) => b.localeCompare(a))
      .map(([date, items], groupIndex, entries) => (
        <TimelineGroup
          key={date}
          date={date}
          items={items}
          groupIndex={groupIndex}
          totalGroups={entries.length}
        />
      ));
  }, [timelineData]);

  return <div className={`space-y-6 ${className}`}>{timelineGroups}</div>;
};

export default React.memo(TimelineStepper);
